import React, { FC, useMemo } from 'react'
import CheckboxListFacet from '../../components/CheckboxListFacet'
import { BaseFacetProps } from '../../types'
import { SizeFacetConnector, SizeFacetConnectorProps } from 'connectors/Facets'
import { convertSizeUnit } from '../../helpers/facets'
import CustomSizeFields from './CustomSizeFields'

const SIZES = ['small', 'medium', 'large', 'oversized']

type SizeFacetProps = BaseFacetProps &
  SizeFacetConnectorProps & {
    isCustomSizeEnabled?: boolean
    facetName?: string
  }

const SizeFacet: FC<SizeFacetProps> = ({
  baseUrl,
  nextAppRoute,
  facetName = 'size',
  isCustomSizeEnabled,
  measurementUnit,
  sizeMinMax,
  getHref,
}) => {
  const overrideSizeRules = useMemo(() => convertSizeUnit(measurementUnit), [measurementUnit])

  return (
    <CheckboxListFacet
      facetName={facetName}
      attributesList={SIZES}
      overrideCheckboxTextRules={overrideSizeRules}
      baseUrl={baseUrl}
      nextAppRoute={nextAppRoute}
    >
      {isCustomSizeEnabled && (
        <CustomSizeFields
          baseUrl={baseUrl}
          nextAppRoute={nextAppRoute}
          getHref={getHref}
          measurementUnit={measurementUnit}
          sizeMinMax={sizeMinMax}
        />
      )}
    </CheckboxListFacet>
  )
}

export default SizeFacetConnector(SizeFacet)
